// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VEciC","rootMobile":"styles_rootMobile__1GFXu"};